<template>
  <section class="auth-page d-flex align-items-center justify-content-center">
    <div class="auth-page__decor" aria-hidden="true">
      <svg class="auth-page__leaf auth-page__leaf--1" viewBox="0 0 48 64" fill="none">
        <path d="M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z" fill="#A5B94F" opacity="0.55" />
        <path d="M24 8v46" stroke="#8FA03E" stroke-width="1.5" stroke-linecap="round" opacity="0.5" />
      </svg>
      <svg class="auth-page__leaf auth-page__leaf--2" viewBox="0 0 48 64" fill="none">
        <path d="M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z" fill="#A5B94F" opacity="0.45" />
        <path d="M24 8v46" stroke="#8FA03E" stroke-width="1.5" stroke-linecap="round" opacity="0.4" />
      </svg>
      <svg class="auth-page__leaf auth-page__leaf--3" viewBox="0 0 48 64" fill="none">
        <path d="M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z" fill="#A5B94F" opacity="0.5" />
        <path d="M24 8v46" stroke="#8FA03E" stroke-width="1.5" stroke-linecap="round" opacity="0.45" />
      </svg>
      <svg class="auth-page__leaf auth-page__leaf--4" viewBox="0 0 48 64" fill="none">
        <path d="M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z" fill="#A5B94F" opacity="0.4" />
        <path d="M24 8v46" stroke="#8FA03E" stroke-width="1.5" stroke-linecap="round" opacity="0.35" />
      </svg>
    </div>

    <div class="auth-page__inner">
      <slot />
    </div>
  </section>
</template>

<style scoped>
.auth-page {
  --color-primary: #6D5EF8;
  --color-secondary: #6A4328;
  --color-bg: #FCF9F6;
  --color-card: #FFFFFF;
  --color-border: #ECE4D9;
  --color-text: #4C372A;
  --color-muted: #8C8176;

  position: relative;
  min-height: 100vh;
  padding: 24px 16px;
  background: var(--color-bg);
  direction: rtl;
  font-family: Vazirmatn, system-ui, "Segoe UI", Tahoma, sans-serif;
  overflow: hidden;
}

.auth-page__decor {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.auth-page__leaf {
  position: absolute;
  width: 36px;
  height: 48px;
}

.auth-page__leaf--1 { top: 8%; right: 18%; width: 42px; height: 56px; transform: rotate(25deg); }
.auth-page__leaf--2 { top: 42%; left: 8%; width: 34px; height: 46px; transform: rotate(-40deg); }
.auth-page__leaf--3 { top: 68%; left: 16%; width: 28px; height: 38px; transform: rotate(55deg); }
.auth-page__leaf--4 { top: 14%; left: 22%; width: 30px; height: 40px; transform: rotate(70deg); }

.auth-page__inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
}
</style>

<style>
.auth-card {
  width: 100%;
  background: #fff;
  border: 1px solid #ECE4D9;
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 8px 32px rgba(76, 55, 42, 0.08);
}

.auth-card__header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.auth-card__logo {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.auth-card__icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f5f3ff;
  color: #6D5EF8;
  font-size: 1.8rem;
}

.auth-card__title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #4C372A;
  margin-bottom: 6px;
}

.auth-card__subtitle {
  color: #8C8176;
  font-size: 0.95rem;
  margin-bottom: 0;
  line-height: 1.6;
}

.auth-card .form-label {
  font-weight: 500;
  color: #4C372A;
}

.auth-card .input-group-text {
  background: #FBF7FC;
  color: #6D5EF8;
  border-color: #ECE4D9;
}

.auth-card .form-control {
  border-color: #ECE4D9;
}

.auth-card .form-control:focus {
  border-color: #6D5EF8;
  box-shadow: 0 0 0 0.2rem rgba(109, 94, 248, 0.15);
}

.auth-card .toggle-pass {
  border-color: #ECE4D9;
  color: #6D5EF8;
}

.auth-card .auth-link {
  font-size: 0.9rem;
  color: #6D5EF8;
  text-decoration: none;
  font-weight: 500;
}

.auth-card .auth-link:hover {
  text-decoration: underline;
}

.auth-card .auth-btn {
  background-color: #6D5EF8;
  color: #fff;
  border: none;
  padding: 0.65rem;
  font-weight: 600;
  border-radius: 12px;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.auth-card .auth-btn:hover:not(:disabled) {
  background-color: #5b4de0;
  transform: translateY(-1px);
}

.auth-card .auth-btn:disabled {
  opacity: 0.7;
}

.auth-card .auth-switch {
  color: #8C8176;
  font-size: 0.95rem;
}

.auth-card .auth-switch a {
  color: #6D5EF8;
  text-decoration: none;
  font-weight: 600;
}

.auth-card .auth-switch a:hover {
  text-decoration: underline;
}

.auth-card .btn-link {
  color: #6D5EF8;
  text-decoration: none;
  font-weight: 500;
}

.auth-card .otp-input {
  letter-spacing: 0.4em;
  font-size: 1.2rem;
  border-color: #ECE4D9;
  border-radius: 12px;
}
</style>
